import { html, LitElement } from 'lit-element';

/**
 * @element markup-wrapper
 * @prop {String} markup - Item's markup
 * @prop {Object} markupSlots - Content for slots that have to replace item types
 */
export class Markup extends LitElement {
  static get properties() {
    return {
      markup: { type: String },
      markupSlots: { type: Object },
    };
  }

  createRenderRoot() {
    return this;
  }

  render() {
    const div = document.createElement('div');

    div.innerHTML = this.markup;

    const mathElements = Array.from(div.querySelectorAll('math'));

    // Content for slots that have to render math elements
    const mathSlots = mathElements.map((mathElement, index) => {
      return html`
        <span class="markup-math-value" slot="math-element-${index}">
          <math-rendering-element
            .label="${mathElement.outerHTML}"
          ></math-rendering-element>
        </span>
      `;
    });

    return html` <slots-wrapper .markup="${this.markup}">
      ${this.markupSlots} ${mathSlots}
    </slots-wrapper>`;
  }
}
